// 表格数据
const tableData = [];

// 弹窗展示控制字段
const dialogVisibleArray = {
  deleteVisible: false, // 启用弹窗
  addVisible: false, // 签约拒绝弹窗
};
// 向外暴露，利于外部引用
export { tableData, dialogVisibleArray };
